export default __webpack_public_path__ + "static/media/card5.c22121f1.png";